import ConfirmationModal from 'components/common/ConfirmationMessage';
import { interpreterName } from 'helpers/interpreterName';
import { effectiveStatus } from 'helpers/effectiveStatus';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { getEyeStyle } from 'components/common/TableColor';
import { getBackgroundStyle } from 'components/common/TableColor';
import { formatDuration } from 'helpers/formatDuration';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { DashboardSelector } from 'slices/dashboardSlice';
import { fetchDashboardAppointments } from 'slices/dashboardSlice';
import { sendDashboardReminder } from "slices/dashboardSlice";
import { previewDashboardReminder } from "slices/dashboardSlice";
import Swal from 'sweetalert2';
// import { PAGELENGTH } from 'components/common/ListLayout';
// import { dashboardSlice } from 'slices/dashboardSlice';
// import { AcceptActionModal } from './AcceptActionModal';

const ListTable = ({ data, paginationParams }) => {
    console.log(paginationParams, 'paginationParams')
    const dispatch = useDispatch();
    const { checkPermission } = usePermissions()
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const [reminderDisabled, setReminderDisabled] = useState(false);
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'datetime',
        sortDirection: 'asc',
    });;
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { dashboard, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(DashboardSelector);

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    // Always confirm first — this button previously fired a mass email on a single click.
    const handleSendReminder = () => {
        dispatch(previewDashboardReminder((ok, info) => {
            if (!ok) {
                Swal.fire({ icon: 'error', title: 'Failed', text: info });
                return;
            }

            const jobs = info?.appointments ?? 0;
            const interpreters = info?.interpreters ?? 0;
            const days = info?.lookback_days ?? 30;

            if (!jobs) {
                Swal.fire({
                    icon: 'info',
                    title: 'Nothing to send',
                    text: `No past-due assigned jobs from the last ${days} days need a reminder.`,
                });
                return;
            }

            Swal.fire({
                icon: 'warning',
                title: 'Send reminder emails?',
                html: `This will email <strong>${interpreters}</strong> interpreter(s) about <strong>${jobs}</strong> past-due job(s) from the last ${days} days.<br/><br/>This cannot be undone.`,
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: `Yes, send ${jobs} reminder(s)`,
            }).then((result) => {
                if (result.isConfirmed) {
                    doSendReminder();
                }
            });
        }));
    };

    const doSendReminder = () => {
        dispatch(sendDashboardReminder((success, message) => {
            if (success) {
                setReminderDisabled(true);
                localStorage.setItem('reminderDisabledTime', Date.now());
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: message,
                });
                } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: message,
                });
                }
            }));
    };
    useEffect(() => {
            const savedTime = localStorage.getItem('reminderDisabledTime');
            if (savedTime) {
                const now = Date.now();
                const hoursPassed = (now - parseInt(savedTime)) / (1000 * 60 * 60);
                if (hoursPassed < 24) {
                setReminderDisabled(true);
                const remainingTime = 24 - hoursPassed;
                setTimeout(() => setReminderDisabled(false), remainingTime * 60 * 60 * 1000);
                } else {
                setReminderDisabled(false);
                localStorage.removeItem('reminderDisabledTime');
                }
            }
    }, []);
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }

    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }


    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    // const viewItemButtonRef = React.useRef()



    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {

        // const callBack = (direction, field, donotSort = false) => {
        //     setSortFields((prevConfigArray, nextConfig) => {
        //         let upgradedSortFields = [];
        //         const currentConfig = prevConfigArray.find(config => config.field === field)
        //         if (currentConfig) {
        //             upgradedSortFields = [...prevConfigArray.filter(config => config.field !== field), { field, direction }];
        //         }
        //         else {
        //             upgradedSortFields = [...prevConfigArray, { field, direction }]

        //         }
        //         // !donotSort && dispatch(fetchVendorPendingJobs(currentPage, { sortFields: JSON.stringify(upgradedSortFields), search: searchTerm }))
        //         return upgradedSortFields;
        //     });

        // }

        // const sortDirection = (field) => {
        //     const index = sortFields?.findIndex(config => config.field === field)
        //     if (index > -1) {
        //         const direction = sortFields[index].direction;
        //         return direction
        //     }
        //     return "asc"

        // }

        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchDashboardAppointments(currentPage, {  ...paginationParams, sortBy: sortBy, sortDirection: dir, search: searchTerm, pageLength: pageLength  }))
        }


        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="appid"
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Service"
                        sortBy="type"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Date"
                        sortBy="datetime"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Duration"
                        sortBy="duration"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Interpreter"
                        sortBy="interpreter_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="JobLocation"
                        sortBy="job_location_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="courtroom"
                        sortBy="job_location_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Cases"
                        sortBy=""
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.map((item, index) => (
                <AppointmentListItem item={item} index={index} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [selectedItems, data]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setActionAccept({
            show: true,
            item: { id },
        });

    }, [])


    const handleCloseActionButton = React.useCallback((id) => {
        // viewItemButtonRef?.current?.click()
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])



    const handleDeclineShow = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setDeclineModal({
            show: true,
            item: { id },
        });

    }, [])

    console.log(paginationParams, 'paginationParams');

    return (
        <div className='mt-4'>

            <ListLayout
                heading={`dashboard jobs`}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                paginationParams={paginationParams}
                key={JSON.stringify(paginationParams)}
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchDashboardAppointments}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                // showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleSendReminder}
                // handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={!checkPermission('Remind Interpreters')}
                // addButtonDisabled={reminderDisabled}
                buttonTitle="Remind Interpreters"
                totalPages={totalPages}
                sortConfig={sortConfig}
                noOfItems={total}
                disableBootstrap = {true}
            // loader={loader}


            >

                {/* <button
                    type='button'
                    hidden
                    ref={viewItemButtonRef} data-bs-toggle="modal" data-bs-target="#viewModal" className='display-none'
                /> */}
                {/* <AcceptActionModal item={actionAccept?.item} onClose={handleCloseActionButton} isOpen={actionAccept.show}/> */}

                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}

            </ListLayout>
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, handleAcceptButton, handleDeclineShow, current_page, pageLength, checkPermission

}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    // Past-start open jobs read as CNC immediately; the 30-min command persists it later
    const rowStatus = effectiveStatus(item);

    console.log(item, "item")
    return (
        <tr>
            {checkPermission('Detail Appointments') ?
            <td className='p-0' style={getBackgroundStyle(rowStatus)}>
                <div className={`eye_area  ${item?.appointment_details?.extra_mileage_request == 1 && 'extra-mileage'}`} style={getEyeStyle(rowStatus)}>
                    <Link to={`/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            :
            <td style={getBackgroundStyle(rowStatus)}>
               {serial}
            </td>}
            <td style={getBackgroundStyle(rowStatus)}>
                {item?.appid || '-'}
                {item?.cases?.some(c => c?.service_type === 'Document Translation') && (
                    <span
                        title="This job includes a Document Translation case"
                        style={{
                            display: 'inline-block',
                            marginTop: 4,
                            padding: '1px 8px',
                            fontSize: 11,
                            fontWeight: 600,
                            lineHeight: 1.6,
                            borderRadius: 10,
                            background: '#ffb82a',
                            color: '#5a3d00',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        📄 Doc Translation
                    </span>
                )}
            </td>
            <td style={getBackgroundStyle(rowStatus)} className='text-transform-capitalize '>
                {rowStatus || '-'}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {item?.appointment_details?.job_location?.by_zoom ? 'Zoom' : 'In Person'}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {item?.datetime ? moment(item?.datetime).format("MMM D, YYYY h:mm A") + " (PST)" : '-'}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {formatDuration(item?.duration)}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {item?.language?.name || '-'}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {interpreterName(item?.interpreter) || '-'}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {item?.appointment_details?.job_location?.name || '-'}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
            {(() => {
                const names = [...new Set(
                    (item?.cases || []).map(c => c.courtroom?.name).filter(Boolean)
                )];
                return names.length > 0 ? names.join(', ') : '-';
            })()}
            </td>
            <td style={getBackgroundStyle(rowStatus)}>
                {item?.cases?.length > 0
                    ? item.cases.map(c => c.case_number).filter(Boolean).join(', ')
                    : '-'}
            </td>
        </tr>
    )
})
export default ListTable